import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import CameraSwitch from '../../assets/images/camera-switch.svg';
import Swal from 'sweetalert2';
import {
 BrowserMultiFormatReader,
 DecodeHintType,
 NotFoundException,
 BarcodeFormat,
} from '@zxing/library';
import { api, PRINT_URL } from '../../Api';
import DOMPurify from 'dompurify';
import beepSound from '../../assets/sound/beep.mp3';
import searchIcon from '../../assets/images/search-icon.svg';
import qrIcon from '../../assets/images/qr-icon.svg';
import './Scan.css';
import 'animate.css';
import Menu from '../../components/scan/Menu';

function Scan() {
 const bgFirst = localStorage.getItem('selectedLayar');
 const bgSecond = localStorage.getItem('selectedLayarNoText');
 const welcomeAnim = localStorage.getItem('header_anim');
 const guestAnim = localStorage.getItem('guest_anim');
 const tableAnim = localStorage.getItem('table_anim');
 const validAnim = localStorage.getItem('valid_anim');
 const groupAnim = localStorage.getItem('group_anim');
 const giftAnim = localStorage.getItem('gift_anim');
 const printAnim = localStorage.getItem('print_anim');
 const tempCat = localStorage.getItem('temp_cat');
 const usherName = localStorage.getItem('name');
 const [isScanning, setIsScanning] = useState(false);
 const [errorMessage, setErrorMessage] = useState('');
 const [successMessage, setSuccessMessage] = useState('');
 const location = useLocation();
 const [showWelcome, setShowWelcome] = useState(
  location.state?.skipWelcome ? false : true
 );
 const [guestData, setGuestData] = useState(null);
 const [hasSubmitted, setHasSubmitted] = useState(false);
 const [bawaAmplop, setBawaAmplop] = useState('bawa');
 const [videoReady, setVideoReady] = useState(false);
 const [alreadyCheckedIn, setAlreadyCheckedIn] = useState(false);
 const [videoDevices, setVideoDevices] = useState([]);
 const [selectedDeviceId, setSelectedDeviceId] = useState(null);
 const [isAnimating, setIsAnimating] = useState(false);
 const [berlakuUntuk, setBerlakuUntuk] = useState(1);
 const [kids, setKids] = useState(0);

 // search
 const [isSearchOpen, setIsSearchOpen] = useState(false);
 const [searchQuery, setSearchQuery] = useState('');
 const [searchResults, setSearchResults] = useState([]);
 const [isSearching, setIsSearching] = useState(false);

 //  video
 const videoRef = useRef(null);
 const scannerRef = useRef(null);
 const touchStartY = useRef(0);

 const processingRef = useRef(false);
 const lastResultRef = useRef(null);

 //  scan
 const scanLockRef = useRef(false);

 const handleQRCodeScan = useCallback(async (qrData) => {
  if (!qrData) return;

  const normalizedQR = qrData.trim().toUpperCase();

  // prevent duplicate
  if (normalizedQR === lastResultRef.current) return;

  // prevent multiple process
  if (processingRef.current) return;

  // hard lock
  if (scanLockRef.current) return;

  scanLockRef.current = true;
  processingRef.current = true;

  lastResultRef.current = normalizedQR;

  // beep immediately when qr detected
  playBeep();

  // stop scanner immediately
  stopScanner();

  Swal.fire({
   title: 'Scan data QR',
   text: 'Mohon Tunggu....',
   allowOutsideClick: false,
   allowEscapeKey: false,
   showConfirmButton: false,
   customClass: {
    title: 'swal-title-font',
    confirmButton: 'swal-btn-font',
    cancelButton: 'swal-btn-font',
   },
   didOpen: () => {
    Swal.showLoading();
   },
  });

  setBawaAmplop('bawa');

  const selectedCustomer = parseInt(
   localStorage.getItem('selectedCustomer'),
   10
  );

  try {
   let tamu;

   // FAIRYX
   if (normalizedQR.startsWith('FAIRYX-')) {
    const code = normalizedQR.replace('FAIRYX-', '');

    const response = await api.get('/fairytale/v1/tamu-qr', {
     params: { kode: code },
    });

    tamu = response.data;
   }

   // FAIRY
   else if (normalizedQR.startsWith('FAIRY-')) {
    const id = normalizedQR.replace('FAIRY-', '');

    const response = await api.get(`/fairytale/v1/tamu-by-id/${id}`);

    tamu = response.data;
   }

   // INVALID QR
   else {
    Swal.close();

    await Swal.fire({
     icon: 'error',
     title: 'QR Tidak Valid',
     text: 'Gunakan QR FairyTale.',
     timer: 1800,
     showConfirmButton: false,
    });

    lastResultRef.current = null;

    return;
   }

   // WRONG EVENT
   if (parseInt(tamu.author, 10) !== selectedCustomer) {
    Swal.close();

    await Swal.fire({
     icon: 'warning',
     title: 'QR Tidak Sesuai',
     text: 'QR tamu bukan untuk acara ini.',
     timer: 1800,
     showConfirmButton: false,
    });

    lastResultRef.current = null;

    return;
   }

   // checked in
   if (tamu.acf?.hadir === true) {
    setAlreadyCheckedIn(true);

    setSuccessMessage('✅ Tamu ini sudah pernah Checkin.');
   } else {
    setAlreadyCheckedIn(false);
   }

   setGuestData(tamu);

   // berlaku untuk
   let berlakuValue = 1;

   if (tamu.kedatangan && !isNaN(parseInt(tamu.kedatangan, 10))) {
    berlakuValue = parseInt(tamu.kedatangan, 10);
   } else {
    const rawBerlaku = tamu.acf?.berlaku_untuk;

    if (rawBerlaku === 'Family') {
     berlakuValue = 5;
    } else {
     berlakuValue = parseInt(rawBerlaku, 10) || 1;
    }
   }

   setBerlakuUntuk(berlakuValue);
   setKids(parseInt(tamu.kids, 10) || 0);

   Swal.close();
  } catch (error) {
   console.error('Error fetching tamu:', error);

   Swal.close();

   await Swal.fire({
    icon: 'error',
    title: 'Tamu Tidak Ditemukan',
    text: 'Silakan scan ulang.',
    timer: 1800,
    showConfirmButton: false,
   });

   lastResultRef.current = null;
  } finally {
   processingRef.current = false;
   scanLockRef.current = false;
  }
 }, []);

 useEffect(() => {
  if (!isScanning || !selectedDeviceId || !videoRef.current) {
   return;
  }

  let mounted = true;

  const hints = new Map();

  // QR ONLY = MUCH FASTER
  hints.set(DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.QR_CODE]);

  const codeReader = new BrowserMultiFormatReader(hints);

  scannerRef.current = codeReader;

  const startScanner = async () => {
   try {
    await codeReader.decodeFromConstraints(
     {
      audio: false,

      video: {
       deviceId: {
        exact: selectedDeviceId,
       },

       facingMode: 'environment',

       // LOWER resolution = FASTER decode
       width: {
        ideal: 1280,
       },

       height: {
        ideal: 720,
       },
      },
     },

     videoRef.current,

     async (result, err) => {
      if (!mounted) return;

      if (result) {
       //  console.log(
       //   'SCANNED:',
       //   result.getText()
       //  );

       handleQRCodeScan(result.getText());

       return;
      }

      if (err && !(err instanceof NotFoundException)) {
       console.log(err);
      }
     }
    );

    // CAMERA ENHANCEMENTS
    const stream = videoRef.current.srcObject;

    if (!(stream instanceof MediaStream)) return;

    const track = stream.getVideoTracks()[0];

    const capabilities = track.getCapabilities();

    // console.log(capabilities);

    // AUTOFOCUS
    try {
     if (
      capabilities.focusMode &&
      capabilities.focusMode.includes('continuous')
     ) {
      await track.applyConstraints({
       advanced: [
        {
         focusMode: 'continuous',
        },
       ],
      });
     }
    } catch (e) {
     console.log('continuous focus unsupported');
    }

    // LIGHT zoom only
    try {
     if (capabilities.zoom) {
      await track.applyConstraints({
       advanced: [
        {
         zoom: Math.min(1.5, capabilities.zoom.max),
        },
       ],
      });
     }
    } catch (e) {
     console.log('zoom unsupported');
    }

    setVideoReady(true);
   } catch (err) {
    console.error('Scanner init failed:', err);

    setErrorMessage('Scanner gagal dimulai.');
   }
  };

  startScanner();

  return () => {
   mounted = false;

   setVideoReady(false);

   if (scannerRef.current) {
    scannerRef.current.reset();
    scannerRef.current = null;
   }
  };
 }, [isScanning, selectedDeviceId, handleQRCodeScan]);

 const startScanner = async () => {
  stopScanner();
  try {
   processingRef.current = false;
   lastResultRef.current = null;

   setGuestData(null);
   setErrorMessage('');
   setSuccessMessage('');
   setAlreadyCheckedIn(false);
   setHasSubmitted(false);

   const permissionStream = await navigator.mediaDevices.getUserMedia({
    video: true,
   });

   permissionStream.getTracks().forEach((track) => track.stop());

   const devices = await navigator.mediaDevices.enumerateDevices();

   const videoInputs = devices.filter((d) => d.kind === 'videoinput');

   if (!videoInputs.length) {
    setErrorMessage('Tidak ada kamera tersedia.');

    return;
   }

   let preferredCamera =
   videoInputs.find((d) => {
    const label = d.label.toLowerCase();
  
    return (
     label.includes('front') ||
     label.includes('user') ||
     label.includes('depan')
    );
   }) || videoInputs[0];

   setVideoDevices(videoInputs);

   setSelectedDeviceId(preferredCamera.deviceId);

   setIsScanning(true);
  } catch (err) {
   console.error(err);

   setErrorMessage(`Mohon izinkan akses kamera. (${err.name})`);

   setTimeout(() => {
    setErrorMessage('');
   }, 2500);
  }
 };

 const stopScanner = () => {
  try {
   if (scannerRef.current) {
    scannerRef.current.reset();
    scannerRef.current = null;
   }

   const video = videoRef.current;

   if (video) {
    const stream = video.srcObject;

    if (stream instanceof MediaStream) {
     stream.getTracks().forEach((track) => track.stop());
    }

    video.pause();

    video.srcObject = null;
   }
  } catch (e) {
   console.log('stopScanner error:', e);
  }

  setVideoReady(false);
  setIsScanning(false);
 };

 //
 const decodeHTML = (html) => {
  const decoded = DOMPurify.sanitize(html);
  const txt = document.createElement('textarea');
  txt.innerHTML = decoded;
  return txt.value;
 };

 const handleSubmit = async () => {
  if (!guestData?.id) return;

  Swal.fire({
   title: 'Proses Checkin. Mohon Tunggu...',
   allowOutsideClick: false,
   didOpen: () => Swal.showLoading(),
  });

  try {
    const finalBawaAmplop =
  tempCat === 'Bugis' ? 'tidak' : bawaAmplop;
   const response = await api.post('/fairytale/v1/update-meta', {
    post_id: guestData.id,
    meta: {
     hadir: '1',
     kedatangan: `${berlakuUntuk}`,
     kids: `${kids}`,
     bawa_amplop: finalBawaAmplop,
    },
   });
   if (response.data?.updated) {
    setGuestData((prev) => ({
     ...prev,
     bawa_amplop: response.data.updated.bawa_amplop,
    }));
   }

  //  setHasSubmitted(true);
  //  setSuccessMessage(`✅ Checkin Berhasil`);

  Swal.fire({
    icon: 'success',
    title: 'Berhasil',
    text: 'Data berhasil disimpan',
    confirmButtonText: 'Tutup',
    confirmButtonColor: '#0185c6',
  }).then(() => {
    startScanner();
  });

  } catch {
   Swal.fire({
    icon: 'error',
    title: 'Error',
    text: 'Terjadi Kesalahan, silahkan coba lagi.',
    confirmButtonColor: '#0185c6',
   });
  }
 };

 const playBeep = () => {
  const audio = new Audio(beepSound);
  audio.play();
 };

 const dismissWelcome = () => {
  if (isAnimating) return;
  setIsAnimating(true);
  setTimeout(() => {
   setShowWelcome(false);
   setIsAnimating(false);
  }, 500); // Match this to your CSS animation duration
 };

 const handleTouchStart = (e) => {
  touchStartY.current = e.touches[0].clientY;
 };

 const handleTouchEnd = (e) => {
  const deltaY = touchStartY.current - e.changedTouches[0].clientY;
  if (deltaY > 50) {
   dismissWelcome();
  }
 };

 const handleCameraSwitch = async () => {
  if (!videoDevices.length) return;

  const currentIndex = videoDevices.findIndex(
   (device) => device.deviceId === selectedDeviceId
  );

  const nextIndex = (currentIndex + 1) % videoDevices.length;

  const nextDeviceId = videoDevices[nextIndex].deviceId;

  setSelectedDeviceId(nextDeviceId);

  stopScanner();

  setTimeout(async () => {
   try {
    const stream = await navigator.mediaDevices.getUserMedia({
     video: {
      deviceId: {
       exact: nextDeviceId,
      },

      width: {
       ideal: 1920,
      },

      height: {
       ideal: 1080,
      },

      facingMode: {
       ideal: 'user',
      },
     },
    });

    if (videoRef.current) {
     videoRef.current.srcObject = stream;

     await videoRef.current.play();
    }

    setIsScanning(true);
   } catch (err) {
    console.error(err);
   }
  }, 300);
 };

 const increaseBerlakuUntuk = () => {
  setBerlakuUntuk((prev) => prev + 1);
 };

 const decreaseBerlakuUntuk = () => {
  setBerlakuUntuk((prev) => (prev > 0 ? prev - 1 : 0));
 };

 // Titles like "Name, S.H. (Jabatan)" put the role on its own line
 const splitGuestTitle = (title) => {
  const match = title.match(/^(.*?)\s*(\([^()]*\))\s*$/);
  return match ? [match[1], match[2]] : [title, ''];
 };
 // The Jabatan field wins; older guests still carry it in the title
 const [guestName, titleRole] = guestData
  ? splitGuestTitle(decodeHTML(guestData.title))
  : ['', ''];
 const guestJabatan = guestData?.acf?.jabatan
  ? decodeHTML(guestData.acf.jabatan)
  : '';
 const guestRole = guestJabatan || titleRole;

 // Bugis: stacked Orang/Anak counters, no gift toggle
 const isBugis = tempCat === 'Bugis';
 const canEditCount = !(hasSubmitted || alreadyCheckedIn);

 const renderStepper = (text, onIncrease, onDecrease) => (
  <div className="checkin-stepper">
   {canEditCount && (
    <button
     type="button"
     className="checkin-stepper__btn"
     onClick={onDecrease}
     aria-label="Kurangi"
    >
     <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 12h14" />
     </svg>
    </button>
   )}
   <div className="checkin-stepper__value">{text}</div>
   {canEditCount && (
    <button
     type="button"
     className="checkin-stepper__btn"
     onClick={onIncrease}
     aria-label="Tambah"
    >
     <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 5v14M5 12h14" />
     </svg>
    </button>
   )}
  </div>
 );

 // search function
 const handleSearch = async () => {
  if (!searchQuery.trim()) return;

  setIsSearching(true);
  setSearchResults([]);

  try {
   const selectedCustomer = parseInt(
    localStorage.getItem('selectedCustomer'),
    10
   );
   // show loading swal
   Swal.fire({
    title: 'Mencari data tamu...',
    allowOutsideClick: false,
    customClass: {
     title: 'swal-title-font',
     confirmButton: 'swal-btn-font',
     cancelButton: 'swal-btn-font',
    },
    didOpen: () => {
     Swal.showLoading();
    },
   });

   const response = await api.get('/fairytale/v1/search-tamu', {
    params: { q: searchQuery, customer: selectedCustomer },
   });

   const results = response.data || [];
   setSearchQuery('');
   setSearchResults(results);
   Swal.close();
   if (results.length === 0) {
    Swal.fire({
     icon: 'warning',
     title: 'Tamu tidak ditemukan',
     text: 'Silakan coba nama lain.',
     confirmButtonText: 'Close',
     customClass: {
      title: 'swal-title-font',
      confirmButton: 'swal-btn-font',
      cancelButton: 'swal-btn-font',
     },
    });
    setSearchQuery(''); // clear input
    setSearchResults([]); // clear results
   }
  } catch (error) {
   console.error('Search error:', error);
   Swal.fire('Error', 'Gagal mencari tamu.', 'error');
  } finally {
   setIsSearching(false);
  }
 };

 // handle click tamu on search
 const handleSelectGuest = async (id) => {
 
  try {
   const response = await api.get(`/fairytale/v1/tamu-by-id/${id}`);
   setGuestData(response.data);
   let berlakuValue = 1;

   if (
    response.data.kedatangan &&
    !isNaN(parseInt(response.data.kedatangan, 10))
   ) {
    berlakuValue = parseInt(response.data.kedatangan, 10);
   } else {
    const rawBerlaku = response.data.acf?.berlaku_untuk;
    if (rawBerlaku === 'Family') {
     berlakuValue = 5;
    } else {
     berlakuValue = parseInt(rawBerlaku, 10) || 1;
    }
   }

   setBerlakuUntuk(berlakuValue);
   setKids(parseInt(response.data.kids, 10) || 0);

   if (response.data.acf?.hadir === true) {
    console.log(response.data.acf?.hadir)
    setAlreadyCheckedIn(true);
    setSuccessMessage('✅ Tamu ini sudah pernah Checkin.');
   }
   setShowWelcome(false);
   setIsSearchOpen(false);
  } catch (error) {
   Swal.fire('Error', 'Tamu tidak ditemukan.', 'error');
  }
 };
 const resetGuest = ({ showWelcomeScreen = false } = {}) => {
  stopScanner();
  setGuestData(null);
  setBawaAmplop('bawa');
  setKids(0);
  setErrorMessage('');
  setSuccessMessage('');
  setHasSubmitted(false);
  setShowWelcome(showWelcomeScreen);
  setAlreadyCheckedIn(false);
  setIsSearchOpen(false);
  setSearchQuery('');
  setSearchResults([]);
 };

 return (
  <div className="scan-page" style={{ backgroundImage: `url(${bgSecond})` }}>

   {showWelcome || isAnimating ? (
    <div
     className={`welcome-screen ${isAnimating ? 'slide-up-out' : ''}`}
     onTouchStart={handleTouchStart}
     onTouchEnd={handleTouchEnd}
     /* Swiping up only works on a touchscreen, so the whole screen doubles
        as a tap target - a click or Enter/Space gets past it on a laptop. */
     onClick={dismissWelcome}
     onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
       e.preventDefault();
       dismissWelcome();
      }
     }}
     role="button"
     tabIndex={0}
     aria-label="Mulai scan"
     style={{
      backgroundImage: `url(${bgFirst})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
     }}
    >
    </div>
   ) : (
    <div className="scan_container fade-in">
     {!guestData && (
      <div className="scan_wrap">
       {errorMessage && (
        <p className="error-message" style={{ color: '#fff' }}>
         {errorMessage}
        </p>
       )}
       {!isScanning && !guestData && !isSearchOpen && (
        <button className="qr-scan-btn" onClick={startScanner}>
         START SCANNER
        </button>
       )}

       {isScanning && (
        <div className="video_container">
         <div className="video_wrap">
          <video
           key={isScanning ? 'active' : 'inactive'}
           ref={videoRef}
           autoPlay
           muted
           playsInline
           onCanPlay={() => setVideoReady(true)}
          ></video>
          <div className="scanner-ui">
           <div className="scanner-mask"></div>

           <div className="scanner-frame">
            <div className="corner top-left"></div>
            <div className="corner top-right"></div>
            <div className="corner bottom-left"></div>
            <div className="corner bottom-right"></div>

            <div className="scanner-grid"></div>
            <div className="scanner-laser"></div>
           </div>
          </div>

          {videoDevices.length > 1 && videoReady && (
           <div
            onClick={handleCameraSwitch}
            className="camera-toggle-btn"
            title="Switch Camera"
           >
            <img src={CameraSwitch} alt="FairyTale" className="CameraSwitch" />
           </div>
          )}
         </div>

         {videoReady && (
          <button className="qr-scan-btn qr-stop-btn" onClick={stopScanner}>
           Stop Scanning
          </button>
         )}
        </div>
       )}
      </div>
     )}
     {guestData && !isSearchOpen && (
      <div className="guest-info checkin-card">
       <h3 className={`checkin-welcome animate__animated ${welcomeAnim}`}>
        WELCOME,
       </h3>

       <div className="print-area">
        <div className={`checkin-guest animate__animated ${guestAnim}`}>
         <h3 className="checkin-guest__name">{guestName}</h3>
         {guestRole && <p className="checkin-guest__role">{guestRole}</p>}
        </div>
        {guestData.acf && (
         <>
          <div className={`checkin-field animate__animated ${tableAnim}`}>
           <p className="checkin-field__label">TABLE / GROUP :</p>
           <p className="checkin-field__value">{guestData.acf.nama_meja}</p>
          </div>

          {guestData.acf.kategori && (
           <div className={`checkin-field animate__animated ${groupAnim}`}>
            <p className="checkin-field__label">CATEGORY :</p>
            <p className="checkin-field__value">{guestData.acf.kategori}</p>
           </div>
          )}

          <div className={`checkin-field animate__animated ${validAnim}`}>
           <p className="checkin-field__label">VALID FOR :</p>
           <div
            className={`checkin-steppers ${
             isBugis ? 'checkin-steppers--stacked' : ''
            }`}
           >
            {renderStepper(
             isBugis ? `${berlakuUntuk} Orang` : `${berlakuUntuk} Person(s)`,
             increaseBerlakuUntuk,
             decreaseBerlakuUntuk
            )}
            {renderStepper(
             isBugis ? `${kids} Anak` : `${kids} Kid(s)`,
             () => setKids((prev) => prev + 1),
             () => setKids((prev) => (prev > 0 ? prev - 1 : 0))
            )}
           </div>
          </div>
         </>
        )}
        {!isBugis && (
        <div className="input-group">
         {hasSubmitted || alreadyCheckedIn ? (
          <div className={`amplop-toggle animate__animated ${giftAnim}`}>
           <label className="checkin-field__label">GIFT</label>
           <div className="toggle-container readonly">
            <div
             className={`toggle-switch ${
              guestData?.bawa_amplop === 'bawa' ? 'active' : 'inactive'
             }`}
            >
             <span className="toggle-icon"></span>
             <div
              className={`toggle-knob ${
               guestData?.bawa_amplop === 'bawa' ? 'right' : 'left'
              }`}
             ></div>
            </div>
           </div>
          </div>
         ) : (
          <div className={`amplop-toggle animate__animated ${giftAnim}`}>
           <label className="checkin-field__label">GIFT</label>
           <div
            className="toggle-container"
            onClick={() =>
             setBawaAmplop(bawaAmplop === 'bawa' ? 'tidak' : 'bawa')
            }
            onTouchStart={(e) =>
             (e.target.dataset.startX = e.touches[0].clientX)
            }
            onTouchEnd={(e) => {
             const startX = parseFloat(e.target.dataset.startX);
             const deltaX = e.changedTouches[0].clientX - startX;
             if (deltaX > 30) setBawaAmplop('bawa');
             else if (deltaX < -30) setBawaAmplop('tidak');
            }}
           >
            <div
             className={`toggle-switch ${
              bawaAmplop === 'bawa' ? 'active' : 'inactive'
             }`}
            >
             <span className="toggle-icon">
              {bawaAmplop === 'bawa' ? '' : ''}
             </span>
             <div
              className={`toggle-knob ${
               bawaAmplop === 'bawa' ? 'right' : 'left'
              }`}
             ></div>
            </div>
           </div>
          </div>
         )}
        </div>
        )}
       </div>

       {!hasSubmitted && !alreadyCheckedIn && (
        <div className={`checkin-actions animate__animated ${printAnim}`}>
         <a
          className="checkin-actions__btn"
          href={`my.bluetoothprint.scheme://${PRINT_URL}?title=${encodeURIComponent(decodeHTML(guestData.title))}&table=${encodeURIComponent(guestData.acf.nama_meja)}&total=${encodeURIComponent(berlakuUntuk)}&group=${encodeURIComponent(guestData.acf.tipe_group)}&usher=${encodeURIComponent(usherName)}&temp_cat=${encodeURIComponent(tempCat)}`}
          rel="noopener noreferrer"
         >
          PRINT
         </a>
         <button
          type="button"
          className="checkin-actions__btn"
          onClick={handleSubmit}
         >
          SAVE
         </button>
        </div>
       )}
       {(hasSubmitted || alreadyCheckedIn) && (
        <div>
         <a
           className="qr-scan-btn on-scan"
           href={`my.bluetoothprint.scheme://${PRINT_URL}?title=${encodeURIComponent(decodeHTML(guestData.title))}&table=${encodeURIComponent(guestData.acf.nama_meja)}&total=${encodeURIComponent(berlakuUntuk)}&group=${encodeURIComponent(guestData.acf.tipe_group)}&usher=${encodeURIComponent(usherName)}&temp_cat=${encodeURIComponent(tempCat)}`}
           rel="noopener noreferrer"
         >
          PRINT
         </a>
        </div>
       )}
       {successMessage && (
        <p
         style={{
          color: '#3e3a39',
          fontWeight: '500',
          fontSize: '30px',
         }}
         className={`success-message`}
         dangerouslySetInnerHTML={{ __html: successMessage }}
        />
       )}
      </div>
     )}
    </div>
   )}
   <div className="scan-toolbar">
    {guestData && (
     <div className="search_icon qr_icon" onClick={() => startScanner()}>
      <img src={qrIcon} alt="qrscan" />
     </div>
    )}
    {!showWelcome && (
     <div className="search_icon" onClick={() => {
       setIsSearchOpen(true);
       setGuestData(null);
       setBawaAmplop('bawa');
       setErrorMessage('');
       setSuccessMessage('');
       setHasSubmitted(false);
       setAlreadyCheckedIn(false);
       setSearchQuery('');
       setSearchResults([]);
       stopScanner();
     }}>
      <img src={searchIcon} alt="search" />
     </div>
    )}
    {!showWelcome && (
     <Menu
      onBackToWelcome={() => {
       resetGuest({ showWelcomeScreen: false });
       setShowWelcome(true);
      }}
     />
    )}
   </div>
   {isSearchOpen && (
    <div className="search-modal">
     <div className="search-box">
      <input
       type="text"
       value={searchQuery}
       onChange={(e) => setSearchQuery(e.target.value)}
       onFocus={() => setSearchResults([])} // hide on focus
       onKeyDown={() => setSearchResults([])} // hide on keydown
       placeholder="CARI NAMA TAMU..."
      />
      {searchResults.length > 0 && (
       <div className="results_search">
        <ul>
         {searchResults.map((tamu) => (
          <li key={tamu.id} onClick={() => handleSelectGuest(tamu.id)}>
           {tamu.title}
          </li>
         ))}
        </ul>
       </div>
      )}
      <div className="button_search">
       <button
        onClick={() => {
         setIsSearchOpen(false);
         setSearchQuery(''); // clear input
         setSearchResults([]); // clear results
        }}
       >
        Close
       </button>
       <button onClick={handleSearch} disabled={isSearching}>
        {isSearching ? 'Searching...' : 'Search'}
       </button>
      </div>
     </div>
    </div>
   )}
  </div>
 );
}

export default Scan;
